<header>
  <app-header (toggleSidenav)="toggleSidenav()" [isMainLayout]="true"></app-header>
</header>

<main [class.vertical-toolbar-active]="isLandscape">
  <ng-container *ngIf="(uiTool.isMobile$ | async)" class="sidenav-container">
    <!-- Mobile sidenav -->
    <mat-sidenav-container class="sidenav-container">
      <mat-sidenav #mobileSidenav mode="over" [opened]="SidenavStore.sidenavOpen">
        <app-sidenav [isMainLayout]="true" [isSidenavOpen]="SidenavStore.sidenavOpen"></app-sidenav>
      </mat-sidenav>

      <!-- Mobile content -->
      <mat-sidenav-content>
        <div class="content">
          <router-outlet></router-outlet>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </ng-container>

  <ng-container *ngIf="!(uiTool.isMobile$ | async)" class="sidenav-container">
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </ng-container>

</main>